import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inflightdetails',
  templateUrl: './inflightdetails.component.html',
  styleUrls: ['./inflightdetails.component.css']
})
export class InflightdetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
